module.exports = __webpack_public_path__ + "static/media/hourglass.4069b4ae.svg";